import type { RouteType$options } from '$houdini';

export type RouteType = 'discovery' | 'quickest' | 'shortest' | 'economic' | 'ecological' | 'alternative';

export const RouteTypeMap: Record<RouteType$options, RouteType> = {
	ALTERNATIVE: 'alternative',
	ECOLOGICAL: 'ecological',
	ECONOMIC: 'economic',
	QUICKEST: 'quickest',
	SHORTEST: 'shortest',
	DISCOVERY: 'discovery',
};

export const RouteTypeOrder: RouteType[] = ['quickest', 'economic', 'ecological', 'alternative'];
